import {Typography} from "@mui/material";


export default function IranSanse(props) {
    return <Typography fontSize={props.fontSize ?? 12}
                       fontFamily='iranSanse-medium'>{props.children}</Typography>

}